import BusyCounterLoadingIndicator from './app/shared/components/busyCounter/busy-counter-loading-indicator';
import PropTypes from 'prop-types';
import React from 'react';
import { withOktaAuth } from '@okta/okta-react';

class LoginCallbackBase extends React.Component {

    state = {
        authenticated: null
    };

    componentDidMount () {

        return this.props.authService
            .handleAuthentication()
            .then( () => this.setState( {
                authenticated: true
            } ) )
            .catch( () => {

                this.setState( {
                    authenticated: false
                } );

            } );

    }

    render () {

        if ( this.props.location.hash === '' ) {

            this.props.history.push( '/' );
            return <BusyCounterLoadingIndicator busyCounter={1} />;

        }

        if ( this.state.authenticated === null ) {

            return <BusyCounterLoadingIndicator busyCounter={1} />;

        }

        if ( this.state.authenticated === false ) {

            return null;

        }

        return null;

    }

}

LoginCallbackBase.displayName = 'LoginCallbackBase';
LoginCallbackBase.propTypes = {
    history: PropTypes.object,
    authService: PropTypes.object,
    location: PropTypes.object
};

export const LoginCallback = withOktaAuth( LoginCallbackBase );
